<script setup lang="ts">
// DATA
// A price in the locale's currency format with its digits masked and blurred, e.g. €##,### in English and ##.### € in Italian
const format: NumberFormatKey = 'currency';
</script>

<template>
    <i18n-n :value="99999" :format="format" tag="span">
        <template #integer="{ integer }">
            <span class="blur-[0.1em]">{{ '#'.repeat(integer.length) }}</span>
        </template>
        <template #group="{ group }">
            <span class="blur-[0.1em]">{{ group }}</span>
        </template>
    </i18n-n>
</template>
